import { useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { api } from "../../../singleton/axios";
import { SenateLatest } from "./useSenateLatest";

interface SenateTradesByNameResponse {
  data: SenateLatest[];
  member: string;
  count: number;
}

interface UseSenateTradesByNameParams {
  name: string;
  enabled?: boolean;
}

export const useSenateTradesByName = ({
  name,
  enabled = true,
}: UseSenateTradesByNameParams) => {
  return useQuery({
    queryKey: ["senate-trades-by-name", name],
    queryFn: async (): Promise<SenateTradesByNameResponse> => {
      const response = await api.get("/senate-trades-by-name", {
        params: { name },
      });
      return response.data;
    },
    enabled: enabled && !!name && name.trim().length > 0,
    staleTime: 10 * 60 * 1000, // 10 minutes - fresher data for better UX
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (isAxiosError(error) && error.response?.status === 404) return false;
      return failureCount < 2;
    },
  });
};

export type { SenateTradesByNameResponse };
